import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import imgSwiper from '../imgSwiper/index.vue';
import contentTitle from '../contentTitle.vue';
import contentText from '../contentText.vue';
import star from '../star.vue';
import VisibleObserver from '../../../../utils/observe.js';
import iframeCom from '../iframeCom.vue';
import { setShowSwiper } from '../../utils';
import { swiperChangeBury } from '../../bury';
import virtualCom from '../virtualCom/index.vue';
import { isBaiduMap } from '../../../../utils';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'MicroNote',
  components: {
    imgSwiper,
    contentTitle,
    contentText,
    star,
    iframeCom,
    virtualCom
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    feedIndex: {
      type: Number,
      default: 0
    },
    newBtnIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      observer: null,
      isBaiduMap: isBaiduMap(),
      iframeHeight: 'auto'
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters('preload', ['swiperPreHeight', 'isIframePre', 'IframeLink'])), mapGetters('url', ['abtest', 'source', 'isTaskOperate'])), mapGetters(['phoneInfo', 'cityId'])), mapGetters('dataList', ['microPoiDetail'])), {}, {
    // 是否展示iframe组件
    visibleIframe() {
      const {
        isIframePre,
        IframeLink,
        feedIndex,
        item = {}
      } = this;
      const hasIframe = isIframePre || IframeLink;
      // 首屏有iframe时并且只在feedIndex === 0时展示iframe，其余情况不展示iframe
      return hasIframe && feedIndex === 0 || item.isIframePage;
    }
  }),
  watch: {},
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions({
    sendFirstScreenCostBury: 'firstScreen/sendFirstScreenCostBury',
    updateReqParams: 'dataList/updateReqParams'
  })), mapMutations({
    setShowLoading: 'setShowLoading'
  })), {}, {
    // 跳转到地图
    jumpToMap() {
      this.$emit('open-Baidu-Map');
    },
    // 横滑卡滑动埋点
    swiperBury(val, index) {
      swiperChangeBury(val, index, this.phoneInfo);
    },
    // swiper切换事件处理
    swiperSlideChange(currNoteData) {
      this.updateReqParams(currNoteData);
    },
    // 展开按钮处理
    contentOpen(currNoteData) {
      this.updateReqParams(currNoteData);
      this.$emit('content-open');
    },
    // 双击轮播图自动点赞
    handleDblClick(index) {
      this.$bus.$emit('btn-active-liked', {
        index,
        type: 'dbl'
      });
    },
    // 首屏时间统计有轮播图时
    imgRender(endTime, isPreLoad = false) {
      this.sendFirstScreenCostBury(endTime, false, isPreLoad);
    },
    showSwiper(item, source) {
      return setShowSwiper(item, source);
    },
    getIframeHeight(val = 'auto') {
      this.iframeHeight = val;
    }
  }),
  created() {
    // 页面开始渲染时，设置loading显示
    if (this.feedIndex === 0) {
      // 显示loading
      this.setShowLoading(true);
    }
  },
  mounted() {
    // 展现埋点时机
    this.observer = new VisibleObserver();
    this.observer.addList('', 'micro-title');
  }
};